import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../../usercontext'
import { updateData, getIdData } from '../../../lib/profiles'

export default function AdminProfileEdit() {
	const [formData, setFormData] = useState({
		name: '',
		surname: '',
		phone: '',
		email: ''
	})

	const { profile } = useAuth()
	const navigate = useNavigate()

	async function GetData() {
		if (profile) {
			const info = await getIdData(profile.id)
			if (info && info[0]) {
				setFormData({
					name: info[0].name || '',
					surname: info[0].surname || '',
					phone: info[0].phone || '',
					email: info[0].email || ''
				})
			}
		}
	}

	useEffect(() => {
		GetData()
	}, [profile])

	const handleInputChange = (e) => {
		const { name, value } = e.target
		setFormData((prevState) => ({
			...prevState,
			[name]: value
		}))
	}

	const handleSubmit = async (e) => {
		e.preventDefault()
		try {
			await updateData({
				id: profile.id,
				...formData
			})
			navigate('/admin/admin-profile')
		} catch (error) {
			console.error('Error updating profile:', error)
			alert('Failed to update profile')
		}
	}

	return (
		<div className="col-xl-9 col-md-8 mx-auto">
			<div className="settings-widget profile-details">
				<div className="settings-menu p-0">
					<div className="profile-heading">
						<h3>Edit Profile Details</h3>
						<p>You have full control to manage your own account setting.</p>
					</div>

					<div className="checkout-form personal-address add-course-info">
						<div className="personal-info-head">
							<h4>Edit Profile Details</h4>
						</div>
						<form onSubmit={handleSubmit}>
							<div className="row">
								<div className="col-lg-6">
									<div className="form-group">
										<label className="form-control-label">First Name</label>
										<input type="text" className="form-control" name="name" value={formData.name} onChange={handleInputChange} />
									</div>
								</div>
								<div className="col-lg-6">
									<div className="form-group">
										<label className="form-control-label">Last Name</label>
										<input type="text" className="form-control" name="surname" value={formData.surname} onChange={handleInputChange} />
									</div>
								</div>
								<div className="col-lg-6">
									<div className="form-group">
										<label className="form-control-label">Phone</label>
										<input type="text" className="form-control" name="phone" value={formData.phone} onChange={handleInputChange} />
									</div>
								</div>
								<div className="col-lg-6">
									<div className="form-group">
										<label className="form-control-label">Email</label>
										<input type="email" className="form-control" name="email" value={formData.email} onChange={handleInputChange} />
									</div>
								</div>
								<div className="update-profile">
									<button type="submit" className="btn btn-primary">
										Save Changes
									</button>
									<button type="button" className="btn btn-secondary ms-2" onClick={() => navigate('/admin/admin-profile')}>
										Cancel
									</button>
								</div>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>
	)
}
